import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "./languageDetector";

import en from "./en.json";
import hi from "./hi.json";
import kn from "./kn.json";
import ml from "./ml.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      hi: { translation: hi },
      kn: { translation: kn },
      ml: { translation: ml },
    },
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
